import type {
  DotLottiePlayer,
} from '@dotlottie/player-component/dist/dotlottie-player';
import type { ForwardedRef, HTMLProps } from 'react';
import {
  forwardRef,
  useEffect,
} from 'react';

type DotLottieProps = Partial<HTMLProps<DotLottiePlayer> | DotLottiePlayer>;

const DotLottie = (
  props: DotLottieProps,
  forwardedRef: ForwardedRef<DotLottiePlayer>,
) => {
  useEffect(() => {
    import('@dotlottie/player-component/dist/dotlottie-player');
  }, []);

  return (
    <dotlottie-player
      ref={forwardedRef}
      {...props}
    />
  );
};

export default forwardRef(DotLottie);
